"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.daysBetweenDates = void 0;
var SECOND_IN_MILLIS = 1000;
var MIN_IN_SECONDS = 60;
var HOUR_IN_MIN = 60;
var DAY_IN_HOURS = 24;
var DAY_TO_MILLIS = SECOND_IN_MILLIS * MIN_IN_SECONDS * HOUR_IN_MIN * DAY_IN_HOURS;
var daysBetweenDates = function daysBetweenDates(dateFrom, dateTo) {
  if (!dateFrom || !dateTo) {
    return 0;
  }
  var fromInMillis = dateFrom;
  var toInMillis = dateTo;
  if (typeof dateFrom === 'string') {
    fromInMillis = Date.parse(dateFrom);
  }
  if (typeof dateTo === 'string') {
    toInMillis = Date.parse(dateTo);
  }
  if (isNaN(fromInMillis) || isNaN(toInMillis)) {
    return 0;
  }
  return (toInMillis - fromInMillis) / DAY_TO_MILLIS;
};
exports.daysBetweenDates = daysBetweenDates;